import omit from 'lodash/omit';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import get from 'lodash/get';
import omitDeep from 'omit-deep-lodash';

const removeUncomparableCaseFields = (caseData) => ({
  ...omit(caseData, 'caseId', 'isFavorite', 'lastAccessed'),
  callees: omitDeep(caseData.callees, 'typeID', 'id'),
  patients: caseData.patients.map((patient) => ({
    ...patient,
    answers: omitDeep(patient.answers, 'id'),
    commands: omitDeep(patient.commands, 'typeID'),
    questions: omitDeep(patient.questions, 'typeID'),
    initialPhysicalAssessments: map(
      // Assessment order might be different between envs
      orderBy(patient.initialPhysicalAssessments, 'location'),
      // Assessment index might move around between environments
      // But what we are interested in is that the label stays the same
      (initialPhysicalAssessment) => ({
        ...omit(initialPhysicalAssessment, 'assessmentIndex'),
        assessment: get(
          patient.physicalAssessments[
            initialPhysicalAssessment.assessmentIndex
          ],
          'label'
        ),
      })
    ),
    physicalAssessments: orderBy(patient.physicalAssessments, 'label'),
    patientLogic: omitDeep(patient.patientLogic, 'typeID', 'statementTargetId', '_databaseID'),
    initialMoulages: orderBy(patient.initialMoulages, 'location'),
    initialStructuralMoulages: orderBy(patient.initialStructuralMoulages, 'location'),
  })),
  medications:
    caseData.medications &&
    caseData.medications.map((med) =>
      med.isCustom ? omit(med, 'typeID', '_databaseID') : med
    ),
  grading: caseData.grading && {
    ...caseData.grading,
    calls: omitDeep(caseData.grading.calls, 'id', 'componentKey', 'subComponentKey'),
    commands: omitDeep(caseData.grading.commands, 'id', 'componentKey', 'subComponentKey'),
    questions: omitDeep(caseData.grading.questions, 'id', 'componentKey', 'subComponentKey'),
    medications: omitDeep(caseData.grading.medications, 'id'),
  }
});

export default removeUncomparableCaseFields;
